export default __webpack_public_path__ + "static/media/ob-03.57710cd6.svg";